/**
 * @description 二维码气泡组件
 */

import {defineComponent} from 'san';
import {QR_CODE_EMPTY_URL} from '../../../../common/const/index';
import styles from './index.module.less';
import {downloadBubbleProps} from './interface';

const DownloadBubble = defineComponent<downloadBubbleProps>({
    template: /* html */ `
        <div class="${styles['popover-wrap']}">
            <div
                class="${styles['popover-wrap-content']}"
                style="
                    background-color: {{bgColor}};
                    border-color: {{borderColor}};
                "
            >
                <img
                    class="${styles['popover-wrap-content-img']}"
                    src="{{downloadImg || _emptyImg}}"
                    alt="下载心响APP二维码"
                />
                <p s-if="{{title}}" class="${styles['popover-wrap-content-title']}">{{title}}</p>
                <p s-if="{{subtitle}}" class="${styles['popover-wrap-content-subtitle']}">{{subtitle}}</p>
                <slot></slot>
            </div>
            <div
                s-if="{{showArrow}}"
                class="${styles['popover-wrap-arrow']}"
                style="
                    background-color: {{bgColor}};
                    border-color: {{borderColor}};
                "
            ></div>
        </div>
    `,
    initData() {
        return {
            bgColor: '#fff',
            borderColor: '#fff',
            downloadImg: '',
            title: '',
            subtitle: '',
            showArrow: true,
            _emptyImg: QR_CODE_EMPTY_URL,
        };
    },
});

export default DownloadBubble;
